import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import {
	CollegeJobStatsResponse,
	PaginatedCollegeJobListResponse,
	CollegeJobDetailResponse,
	CollegeJobListParams,
} from '../models/college-jobs.models';

@Injectable({
	providedIn: 'root'
})
export class CollegePortalJobsService {
	apiUrl = environment.collegePortalApiUrl;

	constructor(private http: HttpClient) {}

	getStats(filters?: { yearOfPassing?: number; course?: string }): Observable<CollegeJobStatsResponse> {
		let httpParams = new HttpParams();
		if (filters?.yearOfPassing) httpParams = httpParams.set('year_of_passing', filters.yearOfPassing.toString());
		if (filters?.course) httpParams = httpParams.set('course', filters.course);
		return this.http.get<CollegeJobStatsResponse>(`${this.apiUrl}/jobs/stats`, { params: httpParams });
	}

	getJobs(params: CollegeJobListParams): Observable<PaginatedCollegeJobListResponse> {
		let httpParams = new HttpParams()
			.set('page', (params.page ?? 1).toString())
			.set('limit', (params.limit ?? 20).toString());

		if (params.search) httpParams = httpParams.set('search', params.search);
		if (params.course) httpParams = httpParams.set('course', params.course);
		if (params.location) httpParams = httpParams.set('location', params.location);
		if (params.deadline) httpParams = httpParams.set('deadline', params.deadline);
		if (params.status) httpParams = httpParams.set('status', params.status);

		return this.http.get<PaginatedCollegeJobListResponse>(`${this.apiUrl}/jobs`, { params: httpParams });
	}

	getJobDetail(jobId: string): Observable<CollegeJobDetailResponse> {
		return this.http.get<CollegeJobDetailResponse>(`${this.apiUrl}/jobs/${jobId}`);
	}
}
